/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var Pin = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M13.5459415,13 C10.2126082,13 8.54594155,13 8.54594155,13 C8.54594155,13 8.54594155,18 8.54594155,18 C8.54594155,18 8.54594155,13 8.54594155,13 C8.54594155,13 6.87927488,13 3.54594155,13 C3.54594155,11.364201 4.3314768,9.9118735 5.5458997,8.99966524 L4.68644589,2.12403473 C4.6179434,1.5760148 5.00666909,1.07622462 5.55468903,1.00772212 C5.59583386,1.00257902 5.63725874,1 5.67872376,1 L11.4131593,1 C11.9654441,1 12.4131593,1.44771525 12.4131593,2 C12.4131593,2.04146502 12.4105803,2.08288991 12.4054372,2.12403473 L11.5459834,8.99966524 C12.7604063,9.9118735 13.5459415,11.364201 13.5459415,13 Z", id: "Combined-Shape", stroke: "#919193", strokeLinejoin: "round", transform: "translate(8.545942, 9.500000) rotate(45.000000) translate(-8.545942, -9.500000) " })));
};
export default Pin;
